"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnagraficaApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class AnagraficaApi extends runtime.BaseAPI {
    /**
     * Inserisce l\'anagrafica in base all\'ndg passato prelevando le informazioni da Anagrafe Cedacri (Auth roles: Admin)
     */
    apiAnagraficaNdgAddGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.ndg === null || requestParameters.ndg === undefined) {
                throw new runtime.RequiredError('ndg', 'Required parameter requestParameters.ndg was null or undefined when calling apiAnagraficaNdgAddGet.');
            }
            const queryParameters = {};
            if (requestParameters.forceInsert !== undefined) {
                queryParameters['forceInsert'] = requestParameters.forceInsert;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Anagrafica/{ndg}/add`.replace(`{${"ndg"}}`, encodeURIComponent(String(requestParameters.ndg))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ClienteDtoFromJSON(jsonValue));
        });
    }
    /**
     * Inserisce l\'anagrafica in base all\'ndg passato prelevando le informazioni da Anagrafe Cedacri (Auth roles: Admin)
     */
    apiAnagraficaNdgAddGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiAnagraficaNdgAddGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Restituisce le informazioni dell\'utente a partire dall\'NDG (Auth roles: Admin)
     */
    apiAnagraficaNdgDettaglioGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.ndg === null || requestParameters.ndg === undefined) {
                throw new runtime.RequiredError('ndg', 'Required parameter requestParameters.ndg was null or undefined when calling apiAnagraficaNdgDettaglioGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Anagrafica/{ndg}/dettaglio`.replace(`{${"ndg"}}`, encodeURIComponent(String(requestParameters.ndg))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ClienteDtoFromJSON(jsonValue));
        });
    }
    /**
     * Restituisce le informazioni dell\'utente a partire dall\'NDG (Auth roles: Admin)
     */
    apiAnagraficaNdgDettaglioGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiAnagraficaNdgDettaglioGetRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Esegue la ricerca dell\'anagrafica utente a partire dall\'NDG (Auth roles: Admin)
     */
    apiAnagraficaNdgRicercaGetRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.ndg === null || requestParameters.ndg === undefined) {
                throw new runtime.RequiredError('ndg', 'Required parameter requestParameters.ndg was null or undefined when calling apiAnagraficaNdgRicercaGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("Bearer", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/Anagrafica/{ndg}/ricerca`.replace(`{${"ndg"}}`, encodeURIComponent(String(requestParameters.ndg))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.DatiAnagraficiCedacriDtoFromJSON(jsonValue));
        });
    }
    /**
     * Esegue la ricerca dell\'anagrafica utente a partire dall\'NDG (Auth roles: Admin)
     */
    apiAnagraficaNdgRicercaGet(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiAnagraficaNdgRicercaGetRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.AnagraficaApi = AnagraficaApi;
